import React, { useEffect, useRef, useState } from 'react';
import { Html5QrcodeScanner } from 'html5-qrcode';
import { Camera } from 'lucide-react';

const QRScanner = ({ onScan }) => {
  const scannerRef = useRef(null);
  const [scannedCode, setScannedCode] = useState(null);

  useEffect(() => {
    const scanner = new Html5QrcodeScanner(
      'qr-reader',
      { 
        fps: 10,
        qrbox: { width: 250, height: 250 },
        aspectRatio: 1.0
      },
      false
    );

    scanner.render(onScanSuccess, onScanError);
    scannerRef.current = scanner;

    function onScanSuccess(decodedText) {
      setScannedCode(decodedText);
      onScan(decodedText);
      scanner.clear();
    }

    function onScanError(error) {
      // Ignore scanning errors (they're very common)
    }

    return () => {
      if (scannerRef.current) {
        scannerRef.current.clear();
      }
    };
  }, [onScan]);

  return (
    <div className="text-center">
      <div className="mb-6">
        <div className="inline-flex p-4 bg-[#8B3A3A]/10 rounded-full mb-4">
          <Camera size={40} className="text-[#8B3A3A]" />
        </div>
        <h2 className="font-heading text-2xl font-bold text-[#2C2416] mb-2">
          Scan Voucher QR Code
        </h2>
        <p className="font-utility text-[#2C2416]/70">
          Position the QR code within the camera view
        </p>
      </div>

      <div id="qr-reader" className="max-w-md mx-auto"></div>

      {scannedCode && (
        <div className="mt-6 p-4 bg-green-100 border border-green-400 rounded-lg">
          <p className="font-utility text-sm text-green-700">
            Scanned: <span className="font-mono font-bold">{scannedCode}</span>
          </p>
        </div>
      )}
    </div>
  );
};

export default QRScanner;
